import Chip from '@mui/material/Chip';
import { alpha } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { styled, useTheme } from '@mui/system';
import { type IndicatorTagT } from 'modules/decision/types/indicators';
import React from 'react';

import {
    getChipColorFromIndicatorTag,
    getChipIconFromIndicatorTag,
    getChipLabel,
} from '../helpers';

const StyChip = styled(Chip, {
    shouldForwardProp: (prop) => prop !== 'chipColor',
})<{ chipColor: string }>(({ chipColor }) => ({
    backgroundColor: alpha(chipColor, 0.2),
    borderWidth: '0',
    color: chipColor,
}));

const IndicatorTag = ({
    indicatorTag,
}: {
    indicatorTag: IndicatorTagT;
}): JSX.Element => {
    const theme = useTheme();

    const { type, value, aggregation } = indicatorTag;
    if (!value) return <></>;

    const { isTruncated, chipLabel } = getChipLabel(value, aggregation);
    const chipColor = getChipColorFromIndicatorTag(type, theme);
    const icon = getChipIconFromIndicatorTag(type, chipColor);

    return (
        <Tooltip enterDelay={500} title={isTruncated ? value : undefined}>
            <StyChip
                chipColor={chipColor}
                icon={icon}
                label={chipLabel}
                size="small"
                variant="outlined"
            />
        </Tooltip>
    );
};

export default IndicatorTag;
